import React from "react";
import { Box } from "@mui/material";
import SearchSection from "../Components/SearchSection";
import DiscoverSection from "../Components/DiscoverSection";
import UserReviews from "../Components/UserReviews";

const Home = () => {
  return (
    <Box component="main" sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <SearchSection />
      <DiscoverSection />
      <UserReviews />
    </Box>
  );
};

export default Home;